import { Outlet } from 'react-router-dom';
import { Sidebar } from '@/components/Sidebar';
import { useAuth } from '@/context/AuthContext';
import { LogOut, User } from 'lucide-react';

export const Layout = () => {
  const { logout, user } = useAuth();

  return (
    <div className="flex min-h-screen bg-[#09090b]" data-testid="app-layout">
      <Sidebar />
      <main className="flex-1 ml-0 md:ml-64 min-h-screen flex flex-col">
        {/* Top Header */}
        <header className="h-16 border-b border-white/5 bg-[#0c0c0e]/50 backdrop-blur-sm flex items-center justify-between px-4 md:px-8 sticky top-0 z-30">
           <div className="md:hidden" /> {/* Spacer for mobile menu toggle */}
           <div className="flex items-center gap-4 ml-auto">
              <div className="hidden md:flex items-center gap-2 text-sm text-[#a1a1aa]">
                 <div className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center">
                    <User className="w-4 h-4" />
                 </div>
                 <span>Admin</span>
              </div>
              <button
                onClick={logout}
                className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-white/5 hover:bg-[#F43F5E]/10 hover:text-[#F43F5E] text-[#a1a1aa] text-sm font-medium transition-colors border border-white/5"
              >
                <LogOut className="w-4 h-4" />
                <span className="hidden sm:inline">Logout</span>
              </button>
           </div>
        </header>

        <div className="flex-1 max-w-[1600px] w-full mx-auto p-4 md:p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
};
